export default {
  methods:{
    twoDigitFormat(num){
      if(num<10){
        return "0"+num;
      }
      return ""+num;
    },
    convertHoursToString(hours){
      let hrs=Math.floor(hours);
      let mins = Math.round((hours%1)*60);
      if (mins>59){
        mins = 0 ;
        hrs++;
      }
      return this.twoDigitFormat(hrs)+":"+this.twoDigitFormat(mins);
    },
    convertStringToHours(string){
      let splited = string.split(":");
      return +splited[0]+(+splited[1]/60);
    },
    invertIntervals(weekItems){
      let keys = Object.keys(weekItems);
      let inverted={};
      for(let i = 0; i < keys.length; i++){
        let key = keys[i];
        let items = weekItems[key];
        let invertedItems = [];
        inverted[key]=invertedItems;
        if(items.length){
          let sortedItems = items.map(item => {
            return [item.start, item.end];
          }).sort((a, b) => {
            return this.convertStringToHours(a[0]) - this.convertStringToHours(b[0]);
          });
          if(sortedItems[0][0]!="00:00"){
            invertedItems.push(["00:00",sortedItems[0][0]]);
          }
          for(let i = 0 ; i < sortedItems.length-1;i++){
            if(sortedItems[i][1]!=sortedItems[i+1][0]){
              invertedItems.push([sortedItems[i][1],sortedItems[i+1][0]]);
            }
          }
          if(sortedItems[sortedItems.length-1][1]!="24:00"){
            invertedItems.push([sortedItems[sortedItems.length-1][1],"24:00"]);
          }
        }else{
          invertedItems.push(["00:00","24:00"]);
        }
      }
      return inverted;
    },
    convertIntervalArraysToObjects(weekItems){
      let keys=Object.keys(weekItems);
      let converted  = {};

      keys.forEach(key=>{
        let arrays=weekItems[key];
        let convAr=[];
        arrays.forEach(array=>{
          convAr.push({start:array[0],end:array[1]});
        });
        converted[key]=convAr;
      });
      return converted;
    }
  }
}
